import React, {useState} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";

import { useFormik } from 'formik';
import {changePassword} from "../../services/auth.service";
import {toast, toastWarning} from "../../utils/utils";
import LoaderWithBackDrop from "../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import {TOAST_TYPES} from "../../utils/constants";
import {Typography} from "@mui/material";


const useStyles = makeStyles((theme)=>({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: "center",
        marginTop: 10,
        marginBottom: 10
    },
    btn: {
        marginTop: 16
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalPaper: {
        backgroundColor: 'none',
        boxShadow: 'none',
        padding: theme.spacing(8, 15, 10),
        overflowY: 'auto'
    },
    infoTitle: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        textAlign: 'center',
        fontSize: '45px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: '32px !important',
        },
    },
    actionButton: {
        background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        color: '#fff !important',
        borderRadius: '10px',
        fontSize: '13px',
        width:'50%',
        textAlign:'center',
        padding: '6px 12px',
        marginRight: theme.spacing(1),
        '&:hover': {
            background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",        },

    },
}));


function ChangePassword(){

    const classes = useStyles();
    const [loading, setLoading] = useState(false);

    const formik = useFormik({
        initialValues: {
            old_password: '',
            new_password: '',
            confirm_new_password: ''
        },
        onSubmit: async (values) => {

            if (values.new_password !== values.confirm_new_password) {
                return toastWarning('Please provide the same password in both password fields!')
            }

            setLoading(true);

            try {
                const result = await changePassword(values.old_password, values.new_password);
                console.log('result.data -> ', result.data);

                toast(TOAST_TYPES.SUCCESS, "Password Changed", "Successfully Changed Password")
            } catch (e) {
                // already toasted the error
            }

            setLoading(false);
        }
    });


    return (
        <div className={classes.container}>

            <div className={classes.modalPaper}>
                <Typography id="transition-modal-title" variant="h4" component="h1" gutterBottom
                            className={classes.infoTitle}>
                    Change Password
                </Typography>
                <br/>
                <form className={classes.form} noValidate onSubmit={formik.handleSubmit}>
                    <Grid container spacing={2} sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <Grid item xs={12}>
                            <TextField
                                style={{backgroundColor: '#fff'}}
                                variant="outlined"
                                required
                                fullWidth
                                name="old_password"
                                label="Old Password"
                                type="password"
                                id="password"
                                autoComplete="current-password"
                                onChange={formik.handleChange}
                                value={formik.values.old_password}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                style={{backgroundColor: '#fff'}}
                                variant="outlined"
                                required
                                fullWidth
                                name="new_password"
                                label="New Password"
                                type="password"
                                id="password"
                                onChange={formik.handleChange}
                                value={formik.values.new_password}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                style={{backgroundColor: '#fff'}}
                                variant="outlined"
                                required
                                fullWidth
                                name="confirm_new_password"
                                label="Confirm New Password"
                                type="password"
                                id="password"
                                onChange={formik.handleChange}
                                value={formik.values.confirm_new_password}
                            />
                        </Grid>

                        <Grid item xs={12} style={{textAlign: 'center', width: '100%'}}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                className={classes.actionButton}
                            >
                                Change
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </div>

            <LoaderWithBackDrop loading={loading} />

        </div>
    );
}

export default ChangePassword;